import { render, staticRenderFns } from "./ScreeningRemarks.vue?vue&type=template&id=0b2b2912&scoped=true"
import script from "./ScreeningRemarks.vue?vue&type=script&lang=js"
export * from "./ScreeningRemarks.vue?vue&type=script&lang=js"
import style0 from "./ScreeningRemarks.vue?vue&type=style&index=0&id=0b2b2912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2b2912",
  null
  
)

export default component.exports